import React from "react";
import { FormControl, FormLabel, Select } from "@chakra-ui/react";

export const FormSelect = ({
  label,
  options = [],
  value,
  placeholder,
  formProps,
  selectOnChange,
  padding,
  name,
  disabled
}) => {
  return (
    <FormControl {...formProps} padding={padding}>
      {label ?
        <FormLabel
          fontSize="15px"
          textTransform="capitalize"
          fontWeight={600}>
          {label}
        </FormLabel> : <></>}
      <Select
        placeholder={placeholder}
        value={value}
        onChange={selectOnChange}
        name={name}
        disabled={disabled}
      >
        {options &&
          React.Children.toArray(options.map((opt) => (
            <option key={opt.id} value={!!opt.value ? opt.value : opt.id}>
              {opt.name}
            </option>
          )))}
      </Select>
    </FormControl>
  );
};
